
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetogoahire() {



    const cardData =
    {
        keyword: 'Pune to Goa Bus Hire',
        heading: 'Amruta Travels: Pune to Goa Bus Hire',
        headingDescription: 'Amruta Travels offers Pune to Goa Bus Hire, delivering a relaxing and reliable travel option for groups heading to the vibrant beaches and nightlife of Goa. Whether you are planning a vacation with friends, a corporate offsite, or a family tour, our spacious and well-maintained buses ensure a smooth and enjoyable ride. Choose from a variety of bus options including 17-seater, 32-seater, and 50-seater to suit your group size. With experienced drivers, punctual departures, affordable pricing, and 24/7 customer support, Amruta Travels makes your Pune to Goa journey safe, comfortable, and full of excitement. Book your Goa trip with us today!',


        top: 'Top Places to Visit in Goa with Amruta Travels',
"topPlaces": [
  {
    "title": "Palolem Beach",
    "description": "A crescent-shaped beach in South Goa, Palolem is known for its serene ambiance, golden sands, and vibrant beach huts. It's ideal for swimming, kayaking, and enjoying the laid-back Goan vibe."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "Located in Old Goa, this UNESCO World Heritage Site houses the mortal remains of St. Francis Xavier. The baroque architecture and historical significance make it a must-visit for history enthusiasts."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Situated on the Goa-Karnataka border, these majestic four-tiered waterfalls are surrounded by lush greenery. The name 'Dudhsagar' translates to 'Sea of Milk' due to the milky appearance of the cascading water."
  },
  {
    "title": "Fort Aguada",
    "description": "Built in the 17th century by the Portuguese, Fort Aguada offers panoramic views of the Arabian Sea. The fort also houses a historic lighthouse, adding to its charm."
  },
  {
    "title": "Anjuna Flea Market",
    "description": "Held every Wednesday, this vibrant market in North Goa is a shopper's paradise. From handmade jewelry to bohemian clothing, it's a great place to pick up unique souvenirs."
  },
  {
    "title": "Fontainhas (Latin Quarter)",
    "description": "Located in Panaji, Fontainhas is known for its narrow winding streets, colorful Portuguese-style houses, and quaint cafes. It's a delightful area to explore on foot."
  },
  {
    "title": "Chapora Fort",
    "description": "Perched atop a hill, Chapora Fort offers stunning views of Vagator Beach and the Arabian Sea. The fort gained popularity after featuring in the Bollywood movie 'Dil Chahta Hai.'"
  },
  {
    "title": "Bhagwan Mahaveer Wildlife Sanctuary",
    "description": "Spanning over 240 square kilometers, this sanctuary is home to diverse flora and fauna, including leopards, deer, and various bird species. It's also the location of the Tambdi Surla Temple."
  },
  {
    "title": "Arambol Beach",
    "description": "A favorite among backpackers, Arambol Beach in North Goa is known for its relaxed atmosphere, live music sessions, and yoga retreats. The nearby freshwater lake adds to its appeal."
  },
  {
    "title": "Goa Chitra Museum",
    "description": "Located in Benaulim, this ethnographic museum showcases over 4,000 artifacts related to Goan traditional agrarian technology and lifestyle. It's a testament to Goa's rich cultural heritage."
  }
],



    "services": [
    {
      "name": "Pune to Goa 17 Seater Bus on Rent",
      "description": "Travel comfortably from Pune to Goa with our 17-seater bus rental. Ideal for small groups, our buses are equipped with AC, spacious seating, and professional drivers to ensure a relaxing and enjoyable journey to Goa's beautiful beaches."
    },
    {
      "name": "Pune to Goa Urbania Bus Hire",
      "description": "Hire the luxurious Force Urbania for your Pune to Goa trip. Perfect for small to medium-sized groups, the Urbania offers plush seating, ample luggage space, and smooth, comfortable travel. A great choice for group travel with a touch of luxury."
    },
    {
      "name": "Pune to Goa AC Bus on Rent",
      "description": "Choose from our fleet of well-maintained AC buses for a comfortable ride from Pune to Goa. Whether you’re going for a family vacation or a corporate trip, our buses provide ample seating, air conditioning, and smooth rides for a hassle-free journey."
    },
    {
      "name": "14 17 25 32 Seater on Rent for Pune to Goa",
      "description": "Amruta Travels offers a range of bus rentals from 14-seater to 32-seater for your Pune to Goa trip. Perfect for family trips, school excursions, or corporate outings, our buses come with AC, plush seating, and professional drivers."
    },
    {
      "name": "35 40 45 50 Seater on Rent for Pune to Goa",
      "description": "For larger groups traveling from Pune to Goa, hire our 35, 40, 45, or 50-seater buses. Whether it's a family reunion or a corporate event, we offer spacious and comfortable buses with all the necessary amenities to make your trip enjoyable and safe."
    },
    {
      "name": "Pune to Goa Bus Package for Trip from Pune",
      "description": "Book a complete bus package for your trip from Pune to Goa. This all-inclusive service includes a round trip, skilled drivers, AC buses, and flexible itineraries, ensuring a seamless and memorable experience for groups of any size."
    },
    {
      "name": "Pune to Goa Bus Hire for Picnic",
      "description": "Plan a fun picnic to Goa with Amruta Travels’ bus hire services. Our buses are perfect for a group trip, with comfortable seating, safety features, and expert drivers. Enjoy a day of sightseeing and relaxation on the beaches of Goa."
    },
    {
      "name": "Pune to Goa Bharat Benz Hire for Picnic",
      "description": "For a premium experience, hire the Bharat Benz bus from Pune to Goa for your picnic trip. With plush interiors, spacious seating, and AC, this luxury bus ensures a first-class travel experience, making your Goa getaway even more special."
    }
  ],
  "tableData": [
    ["Pune to Goa 17 Seater Bus on Rent", "Pune to Goa Urbania Bus Hire"],
    ["Pune to Goa AC Bus on Rent", "14 17 25 32 Seater on Rent for Pune to Goa"],
    ["35 40 45 50 Seater on Rent for Pune to Goa", "Pune to Goa Bus Package for Trip from Pune"],
    ["Pune to Goa Bus Hire for Picnic", "Pune to Goa Bharat Benz Hire for Picnic"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Scenic Travel from Pune to Goa",
    "WhyChoosedescription": "Amruta Travels offers Pune to Goa Bus Hire services that deliver the perfect mix of comfort, reliability, and scenic beauty. Enjoy a relaxed ride through the Western Ghats and Konkan routes with our air-conditioned, push-back seating buses—ideal for long-distance travel. Whether it’s a weekend getaway, group holiday, or special event, our buses provide a smooth and enjoyable journey to India’s favorite beach destination."
  },
  {
    "WhyChooseheading": "Ideal for Group Tours, Parties, and Corporate Retreats",
    "WhyChoosedescription": "Planning a trip with friends, a corporate offsite, or a college tour to Goa? Our fleet of 17 to 50 seater buses is perfect for small and large groups. With ample space, entertainment systems (on request), and storage for luggage and beach gear, your group can travel together, have fun on the road, and arrive in Goa refreshed and ready for adventure."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Goa Routes",
    "WhyChoosedescription": "Our professional drivers have years of experience navigating the Pune to Goa stretch, including the Amboli Ghat, Sawantwadi, and Chorla routes. They ensure timely arrivals and prioritize safety, even on winding or hilly terrain. Courteous and cooperative, our drivers are a key part of making your trip stress-free and enjoyable."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "We offer competitive and transparent pricing for Pune to Goa Bus Hire. Whether you're planning a one-way trip or a round-trip journey, our packages are flexible and cost-effective. You’ll receive clear quotes with no hidden fees—just value-for-money transport solutions tailored to your itinerary and group size."
  },
  {
    "WhyChooseheading": "Clean, Well-Maintained Buses for Long-Distance Travel",
    "WhyChoosedescription": "Our buses are regularly serviced, sanitized, and inspected for optimal performance. With features like reclining seats, air conditioning, and clean washroom breaks scheduled along the way, we make sure your group enjoys a comfortable and hygienic experience throughout the long Pune to Goa drive."
  },
  {
    "WhyChooseheading": "Customized Pickup and Drop-off Points",
    "WhyChoosedescription": "We offer flexible pickup from anywhere in Pune—be it your society, college, office, or event venue—and drop-off at your chosen hotel, resort, or beachside location in Goa. We adapt to your travel plans, so your group has complete convenience from start to finish."
  },
  {
    "WhyChooseheading": "Flexible Itineraries for North or South Goa Plans",
    "WhyChoosedescription": "Whether you're heading to the beaches of Baga, the nightlife of Anjuna, the serenity of Palolem, or the churches of Old Goa—we tailor your route accordingly. Stop for sightseeing, meals, or photo sessions along the way. Our team helps you plan an itinerary that matches your pace and preferences."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking and Reliable Customer Support",
    "WhyChoosedescription": "Booking your Pune to Goa bus is easy with Amruta Travels. Choose from online booking, phone support, or visit our office. Our travel consultants assist you with vehicle selection, route planning, and any special requests. We offer round-the-clock support for last-minute changes or assistance during travel."
  }
]



















    }

const faqData = [
  {
    question: 'How can I hire a bus from Pune to Goa?',
    answer: 'Hiring a bus from Pune to Goa with Amruta Travels is easy. You can call us, book online, or visit our office. We’ll help you choose the right bus based on your group size, travel preferences, and itinerary.',
  },
  {
    question: 'What types of buses are available for the Pune to Goa route?',
    answer: 'We offer a range of buses including 32, 35, 40, 45, and 50-seater options. You can choose between standard, AC, non-AC, and luxury buses, all equipped for long-distance comfort.',
  },
  {
    question: 'How long does it take to travel from Pune to Goa by bus?',
    answer: 'The journey from Pune to Goa typically takes 10 to 12 hours, depending on the route and traffic. Our experienced drivers ensure a safe and smooth ride throughout.',
  },
  {
    question: 'Is it safe and comfortable to travel to Goa by bus?',
    answer: 'Yes, all our buses are well-maintained, sanitized, and equipped with push-back seats, air conditioning, and spacious interiors. We prioritize your safety and comfort for long trips.',
  },
  {
    question: 'Can I book a round-trip bus service from Pune to Goa?',
    answer: 'Absolutely. We offer both one-way and round-trip bookings. You can customize your return date and schedule as per your convenience.',
  },
  {
    question: 'Are the buses available for group tours and corporate outings to Goa?',
    answer: 'Yes, our buses are ideal for group travel, family vacations, corporate offsites, college tours, and destination events in Goa. We handle both large and small group bookings.',
  },
  {
    question: 'How much does it cost to hire a bus from Pune to Goa?',
    answer: 'Pricing depends on the bus type, number of passengers, and duration of your stay. Contact us with your travel details for a clear and customized quote.',
  },
  {
    question: 'Can I include sightseeing in Goa with the bus rental?',
    answer: 'Yes, we can include local sightseeing in Goa as part of your itinerary. Let us know your plan and we’ll provide a driver who’s familiar with popular destinations and routes.',
  },
  {
    question: 'Why choose Amruta Travels for Pune to Goa bus hire?',
    answer: 'Amruta Travels is trusted for long-distance group travel. We offer comfortable buses, experienced drivers, 24/7 support, and flexible packages to make your Pune to Goa journey seamless and enjoyable.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Kunal Shah',
    role: 'Corporate HR Manager, Pune',
    text: 'We booked a 50-seater bus from Amruta Travels for our company’s Goa offsite. Everything was perfectly arranged. The bus was clean and on time, and the driver was professional. Highly recommended for corporate travel!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha More',
    role: 'Trip Organizer, Pune',
    text: 'We hired a 40-seater luxury bus for our college group tour to Goa. The journey was comfortable, and the service was excellent. Amruta Travels made our trip fun and worry-free.',
    rating: 5,
  },
];






















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Bus Hire",
  "image": "https://bushireinpune.com/assets/images/pune-to-goa-bus-hire.jpg",
  "description": "Hire buses from Pune to Goa for group trips, picnics, and weekend getaways. Choose from 14, 17, 25, 32, 35, 40, 45, and 50 seater buses. Options include AC buses, Urbania, and BharatBenz vehicles. Book your Pune to Goa tour bus package with Amruta Travels for a comfortable and safe journey.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7215"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5999",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-goa-bus-hire"
  }
};






    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Pune to Goa Bus Hire | Tour, Picnic & Group Packages | Amruta Travels</title>
  <meta 
    name="description" 
    content="Book Pune to Goa bus hire with 14 to 50 seater options including Urbania and BharatBenz. Ideal for trips, picnics, and AC bus packages from Pune to Goa. Travel safely with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/42.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetogoahire;